import { Box } from "@chakra-ui/react";

export default function StopButton(props) {
  return (
    <Box
      bg="warningBase"
      p="6px 14px"
      transition="all 300ms"
      borderRadius="16px"
      _hover={{ bg: "warningLighter" }}
      _active={{ bg: "warningDarker" }}
      {...props}
    >
      <Box bg="white" width="12px" borderRadius="1.1px" height="12px" />
    </Box>
  );
}
